import Avatar from "./Avatar";
import TextInfo from "./TextInfo";
import {ProfileModel} from "../../features/profile/profileTypes";
import UserInfoList from "./UserInfoList";
import Trophies from "./Trophies";
import EditIcon from "./EditIcon";
import React from "react";

type Props = {
    profile: ProfileModel
};

const LeftContent = ({profile}: Props) => {
    return (
        <div className='p-2 anim-delay-medium'>
            <div className='text-center pop-in' style={profile.banner_enabled ? {marginTop: '-95px'} : {}}>
                <Avatar src={profile.avatar}/>
            </div>
            <h3 className='user-fullname text-center mb-1 editable mt-1 slide-left'>{profile.fullname}<EditIcon /></h3>

            <UserInfoList profile={profile}></UserInfoList>
        </div>
    )
}

export default LeftContent;
